import { ButtonDropdown, Flex, Space, Text } from '@billy/design-system'
import { ReactElement, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useBookkeepingItemsContext } from '../../../../../../../contexts/bookkeepingItemsContext'
import { BookkeepingItemSortProperty } from '../../../../../enums/bookkeepingItemSortProperty'
import { getDrawerListSortOptions, SortValue } from '../../../../../utils/getDrawerListSortOptions'

export const BookkeepingItemsListSort = (): ReactElement => {
  const { t } = useTranslation()
  const { filters, setFilters } = useBookkeepingItemsContext()

  const sortOption = `${filters.sortProperty}_${filters.sortDirection}`

  const sortItems = useMemo(
    () =>
      getDrawerListSortOptions({
        amountProperty: BookkeepingItemSortProperty.Amount,
        dateProperty: BookkeepingItemSortProperty.Date,
        t,
      }),
    [t],
  )

  const handleSortChange = useCallback(
    (_id?: string, value?: SortValue<BookkeepingItemSortProperty>) => {
      if (value) {
        setFilters({ sortProperty: value.sortProperty, sortDirection: value.sortDirection })
      }
    },
    [setFilters],
  )

  return (
    <Flex alignItems="center">
      <Text>{t('bank_transactions.drawer.sort_by_label')}:</Text>
      <Space size="s8" />
      <ButtonDropdown
        items={sortItems}
        selectedId={sortOption}
        onSelect={handleSortChange}
        variant="text"
        dropdownId="bookkeeping-items-sort-dropdown"
        placement="bottom-start"
      />
    </Flex>
  )
}
